import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './ResultsEmptyState.styles';

type ResultsEmptyStateProps = {
  title?: string;
  message?: string;
  resetButton?: ReactNode;
};

export const ResultsEmptyState = ({
  title,
  message,
  resetButton,
}: ResultsEmptyStateProps) => {
  const { t } = useTranslation(['screener']);

  return (
    <S.Container data-testid="no-results">
      <img
        src="/app/static/images/icons/no-assets-found.svg"
        alt="no assets found"
      />
      <S.Title>{title ?? t('screener:emptyTitle')}</S.Title>
      <S.Message>{message ?? t('screener:emptyMessage')}</S.Message>
      {resetButton}
    </S.Container>
  );
};

ResultsEmptyState.Styled = S;
